// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.DataSourceSortDirection
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSEnum.vm
// If you need to 'extend' the enum, create another file with module of the same name and add functions to it...

export let DataSourceSortDirection = /*#__PURE__*/function (DataSourceSortDirection) {
  DataSourceSortDirection[DataSourceSortDirection["ASCENDING"] = 0] = "ASCENDING";
  DataSourceSortDirection[DataSourceSortDirection["DESCENDING"] = 1] = "DESCENDING";
  return DataSourceSortDirection;
}({});
(function (_DataSourceSortDirection) {
  function fromJson(enumVal) {
    // Canonically always return numeric representation of enum (NOT a string!)
    // An enumVal of either string or number will return undefined if invalid (out of range)
    return typeof enumVal === "number"
    // For safety, check for number in range, if not return undefined
    ? DataSourceSortDirection[enumVal] != null ? enumVal : undefined : DataSourceSortDirection[enumVal];
  }
  _DataSourceSortDirection.fromJson = fromJson;
  function name(enumIndex) {
    return this[enumIndex];
  }
  _DataSourceSortDirection.name = name;
  function indexOf(enumVal) {
    return enumVal; // Erasure....
  }
  _DataSourceSortDirection.indexOf = indexOf;
})(DataSourceSortDirection || (DataSourceSortDirection = {}));
//# sourceMappingURL=DataSourceSortDirection.js.map
